import {StarFilled, StarOutlined} from '@ant-design/icons'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import TagSelect from '../../SidePanel/RightPanel/PropertiesControllerTagSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Toggle from '../../SidePanel/RightPanel/PropertiesControllerToggle.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelBdlogic.mjs'
import SrcType from '../components/SrcType.mjs'
import DomainKnowledge from '../BD/PropertiesPaneControllerDomainKnowledge.jsx'
import ButtonMakeSf from './PropertiesPaneButtonMakeSf.jsx'
import ButtonExportFpReqDoc from './ButtonExportFpReqDoc.jsx'
import getRuleType from './RuleType.jsx'

const PropertiesPaneBdlogic = (props) => {
    const map = useMapContext()
    const RuleType = getRuleType(map)

    return (
        <ComponentPropertiesPane
            buttons={<>
                <ButtonMakeSf />
                <ButtonExportFpReqDoc />
            </>}

            controllers={
                <>
                    <Text
                        prop="ruleTitle"

                        labelSuffix={
                            <Toggle
                                prop="ruleStar"
                                color="#ff4d4f"
                                trueIcon={<StarFilled />}
                                falseIcon={<StarOutlined />}
                            />
                        }
                    />

                    <Text prop="ruleUserCode" />

                    <Select
                        options={RuleType}
                        prop="ruleType"
                    />

                    <Select
                        options={[['1', '是'], ['0', '否']]}
                        prop="iterativeFlag"
                    />

                    <Select
                        options={SrcType}
                        prop="srcType"
                    />

                    <TagSelect prop="ruleKey" />
                    <LongText prop="url" />
                    <LongText prop="feignMethod" />
                    <LongText prop="resume" />
                    <DomainKnowledge />
                    <LongText prop="subUrl" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        'DtReferenceCall',
                        //'Depend',
                        'Effect',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}

export default PropertiesPaneBdlogic
